import React from "react";
import { Link } from "react-router-dom";
export default function Unavailable() {
  return (
    <article className="research-card">
      <h1>This feature is outside the current preview.</h1>
      <p>
        The earlier tools have been withdrawn while verified research is built.
      </p>
      <Link to="/research">Start property research</Link>
    </article>
  );
}
